/**
 * Lazy-load for <video class="js-lazy-video"> with <source data-src="…">.
 * Replaces the autoptimize/lazysizes-dependent behavior — vanilla IntersectionObserver.
 *
 * Markup (rendered in Html::background()):
 *   <video autoplay muted loop playsinline preload="none" class="js-lazy-video">
 *     <source data-src="…video.mp4" type="video/mp4">
 *   </video>
 *
 * On viewport intersection: data-src → src on all <source> inside, then video.load().
 */
(function () {
  function activate(video) {
    var sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) return;
    sources.forEach(function (s) {
      s.setAttribute('src', s.getAttribute('data-src'));
      s.removeAttribute('data-src');
    });
    try { video.load(); } catch (e) {}
    video.classList.remove('js-lazy-video');
  }

  function init() {
    var videos = document.querySelectorAll('video.js-lazy-video');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      // Old browsers — activate immediately (per the requirement — not a concern).
      videos.forEach(activate);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        activate(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '200px 0px' });

    videos.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
